import {Filter} from "@UI/components/icons/Filter.tsx";
import {Button, ButtonType} from "@UI/components/controls/Button/Button.tsx";
import {ColorNames} from "@UI/theme/generated/ColorNames.ts";
import {Stack} from "@src/CommonComponents/Stack/Stack.tsx";
import styles from "./button.module.less"
import {useModalStore} from "@src/Layers/ModalLayer/ModalStore.ts";
import {Body_10_Coral_Strong_emphasis_10} from "@UI/typography/generated/typography.tsx";
import {useFilters} from "@src/utils/useFilters.ts";
import {FiltersModal} from "@src/Modals/FiltersModal.tsx";


export const FiltersButton = () => {
    const setActiveModal = useModalStore(x => x.setActiveModal)
    const {filtersCount} = useFilters()

    return (
        <Stack className={styles.root} onClick={() => {
            setActiveModal(<FiltersModal/>)
        }}>
            <Button
                className={styles.filterButton}
                color={ColorNames.OBSIDIAN}
                icon={<Filter size={22}/>}
                type={ButtonType.text}

            />
            {filtersCount > 0 &&
                <Stack className={styles.filtersCounter} alignItems={"center"} justifyContent={"center"}>
                    <Body_10_Coral_Strong_emphasis_10>
                        {filtersCount}
                    </Body_10_Coral_Strong_emphasis_10>
                </Stack>
            }
        </Stack>
    )
}